import { ReactElement, ReactNode } from "react";
import { ButtonProps } from "../../Inputs/Button/Button";
import { SrDialog, SrDialogProps } from "./SrDialog";

/** @deprecated - use SrDialog.Åction instead */
export type DialogAction = { name: string; label: ReactNode } & Omit<ButtonProps, "children">;

/** @deprecated - use SrDialogProps instead */
export type DialogProps = {
  name: string;
  title?: ReactNode;
  content?: ReactNode;
  actions?: DialogAction[];
} & Omit<SrDialogProps, "children" | "title" | "content">;

/** @deprecated - use SrDialog instead */
export const Dialog = ({
  open,
  name,
  title,
  content,
  actions,
  ...rest
}: DialogProps): ReactElement => {
  return (
    <SrDialog open={open} name={name} {...rest}>
      {title ? <SrDialog.Title>{title}</SrDialog.Title> : null}
      {content ? <SrDialog.Content>{content}</SrDialog.Content> : null}
      {actions?.length ? (
        <SrDialog.Actions>
          {actions.map(({ name, label, ...props }) => (
            <SrDialog.Action key={name} name={name} variant="text" {...props}>
              {label}
            </SrDialog.Action>
          ))}
        </SrDialog.Actions>
      ) : null}
    </SrDialog>
  );
};
